"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledChip = _styledComponents["default"].span.withConfig({
  displayName: "Chipstyle__StyledChip",
  componentId: "sc-xz5t09-0"
})(["", ""], function (props) {
  var outlined = props.outlined,
    type = props.type;
  var _props$theme = props.theme,
    palette = _props$theme.palette,
    typography = _props$theme.typography,
    spacing = _props$theme.spacing,
    chips = _props$theme.extra.chips;
  var colors = {};
  switch (type) {
    case 'primary':
      {
        colors = {
          border: chips.primary,
          background: chips.primary,
          text: chips.primary
        };
        break;
      }
    case 'secondary':
      {
        colors = {
          border: chips.secondary,
          background: chips.secondary,
          text: chips.secondary
        };
        break;
      }
    case 'success':
      {
        colors = {
          border: chips.success,
          background: chips.success,
          text: chips.success
        };
        break;
      }
    case 'warning':
      {
        colors = {
          border: chips.warning,
          background: chips.warning,
          text: chips.warning
        };
        break;
      }
    case 'error':
      {
        colors = {
          border: chips.error,
          background: chips.error,
          text: chips.error
        };
        break;
      }
    default:
      {
        colors = {
          border: chips["default"],
          background: chips["default"],
          text: chips["default"]
        };
        break;
      }
  }
  return (0, _styledComponents.css)(["display:flex;height:", ";align-items:center;justify-content:center;min-width:120px;padding:", " ", ";text-align:center;font-weight ", ";font-style:italic;line-height:", ";font-family:", ";border-radius:", ";font-size:", ";", "}"], spacing.basePlus, spacing.xTiny, spacing.xSmall, typography.weight.semiBold, typography.lineHeight.paragraph, typography.font.primary, spacing.base, typography.size.misc, outlined ? (0, _styledComponents.css)(["color:", ";border:1px solid ", ";background-color:", ";"], colors.text, colors.border, palette.basic.white) : (0, _styledComponents.css)(["color:", ";background-color:", ";"], palette.basic.white, colors.background));
});
StyledChip.displayName = 'StyledChip';
var _default = exports["default"] = StyledChip;